// src/context/CurrencyContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

const CurrencyContext = createContext(null);

export const currencyData = {
  FCFA: { name: "Niger CFA Franc", symbol: "FcFa", position: "after" },
};

const FALLBACK_RATES = {
  FCFA: 1,
};

export const CurrencyProvider = ({ children }) => {
  const { user } = useAuth();
  const [currency, setCurrency] = useState("FCFA");
  const [rates] = useState(FALLBACK_RATES);

  useEffect(() => {
    setCurrency("FCFA");
    localStorage.setItem("chafadi-currency", "FCFA");
  }, [user]);

  const changeCurrency = () => {
    setCurrency("FCFA");
    localStorage.setItem("chafadi-currency", "FCFA");
  };

  const value = { currency, changeCurrency, rates };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  return useContext(CurrencyContext);
};
